import { Box, Typography } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { COLOR_BLACK, COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { CheckBoxIcon } from "shared/theme/icons/CheckBoxIcon";
import { CheckedBoxIcon } from "shared/theme/icons/CheckedBoxIcon";
import AutocompleteHint from "./components/AutocompleteHint";

type AutocompleteTagProps = {
  optionName: string;
  selected: boolean;
  disabled?: boolean;
  hintText: string;
  isAddedManually?: boolean;
  isAddedByTag?: boolean;
};

function AutocompleteTag({
  optionName,
  selected,
  disabled = false,
  hintText,
  isAddedManually = false,
  isAddedByTag = false,
  ...props
}: AutocompleteTagProps & React.HTMLAttributes<HTMLLIElement>) {
  return (
    <li
      {...props}
      style={{
        opacity: disabled ? 0.4 : 1,
      }}
    >
      <Box display="flex" alignItems="center" width="100%" padding="6px 8px">
        <Checkbox
          icon={<CheckBoxIcon />}
          checkedIcon={<CheckedBoxIcon />}
          style={{ marginRight: 8 }}
          checked={selected}
          disabled={disabled}
        />
        <Box flexGrow={1}>
          <Typography color={COLOR_BLACK} variant="bodyMRegular">
            {optionName}
          </Typography>
        </Box>
        {isAddedManually && isAddedByTag && (
          <AutocompleteHint
            mainText="Added manually, also matches tags"
            mainColor={COLOR_PRIMARY_MAIN}
            selectedValue={hintText}
          />
        )}
        {isAddedManually && !isAddedByTag && (
          <AutocompleteHint
            mainText="Added manually"
            mainColor={COLOR_PRIMARY_MAIN}
            fontWeight={500}
          />
        )}
        {isAddedByTag && !isAddedManually && (
          <AutocompleteHint
            mainText="Added by tag"
            mainColor={COLOR_BLACK}
            selectedValue={hintText}
          />
        )}
      </Box>
    </li>
  );
}

export default AutocompleteTag;
